export enum OperationsSortCriteria {
  DEFAULT = 'Default',
  NAME = 'Name',
  REQUEST_COUNT = 'Request count',
  TOTAL_DURATION = 'Total duration',
  MAX_DURATION = 'Max duration',
}
